/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Node } from "@msdyn365-commerce-modules/utilities";
import * as React from "react";
import { ICartIconViewProps } from "@msdyn365-commerce-modules/cart/src/modules/cart-icon/./cart-icon";
// import currencyFormatter from "currency-formatter";
import CartLine from "../views/components/cartlineitem.component";
import { useState, useEffect } from "react";
import { getProductsReferenceNumberAsync } from "../actions/get-reference-number";

const RenderCartlines = (props: any): any => {
  const { cartLines, prop } = props;

  //const [productTypes, setProductTypes] = useState<any>([]);
  const [referenceNumber, setReferenceNumber] = useState<any>([]);

  let pids: any = [];

  let recordIds: any = [];

  useEffect(() => {
    const items =
      cartLines &&
      cartLines.map((line: any) => {
        return line.data.cartline;
      });

    items?.map((data: any) =>
      pids.indexOf(data.ProductId) == -1 ? pids.push(data.ProductId) : ""
    );

    items?.map((data: any) => recordIds.push(data.ProductId));

    if (pids.length > 0 && referenceNumber.length == 0) {
      getProductsReferenceNumberAsync(
        { callerContext: prop.context.actionContext },
        pids
      ).then((res: any) => {
        var refArray: any[] = [];
        res?.map((d: any) => {
          refArray[d.Id] = d.ReferenceNumber;
        });
        setReferenceNumber(refArray);
      });
    }
  }, []);

  const currencyCode: any = prop.data.customerInformation?.result?.CurrencyCode;

  if (!cartLines) {
    prop.context.telemetry.error(
      "Cartlines content is empty, module wont render"
    );
    return null;
  }

  return cartLines.map((cartLine: any, index: any) => {
    return (
      <Node {...prop.miniCartItemWrapper} key={index}>
        <CartLine
          {...cartLine?.cartline?.props}
          data={cartLine.data}
          currencyCode={currencyCode}
          priceTranslation={prop.resources.price}
          isCartIcon={true}
        />
        <div className="msc-cart-lines-item__price">
          {prop.context.cultureFormatter.formatCurrency(
            Number(cartLine.data?.product?.Price)
          )}
        </div>
        <span className="msc-cart-lines-item__sku">
          {prop.resources.referenceNumber}:{" "}
          {referenceNumber[cartLine.data.product?.RecordId]
            ? referenceNumber[cartLine.data.product?.RecordId]
            : null}
        </span>
        {cartLine.storeLocation}
        {cartLine.remove}
      </Node>
    );
  });
};

const CartIconView: React.FC<ICartIconViewProps> = (props: any) => {
  let price = 0;
  props?.cartlines?.map((d: any) => (price += d.data.cartline.TotalAmount));
  var counter = 0;
  // let [counterDis, setCounterDis] = React.useState<number>(0);
  props?.cartlines?.map((element: any, index: any) => {
    element.cartline.props.data.cartLine.DiscountLines.map((d: any) => {
      if (d.CustomerDiscountTypeValue == 3) {
        counter += d.EffectiveAmount;
      }
    });
  });
  return (
    <Node {...props.miniCartWrapper} {...props.renderModuleAttributes(props)}>
      {props.cartIcon}
      {props.FlyoutContainer ? (
        <Node {...props.FlyoutContainer}>
          {props.flyoutTitle}
          <Node {...props.CartlinesWrapper}>
            <RenderCartlines cartLines={props.cartlines} prop={props} />
          </Node>

          <div className="ms-cart-icon__subtotal">
            {counter != 0 ? (
              <div>
                <span>{props.resources.cartDiscount}</span>
                <span>
                  : -{props.context.cultureFormatter.formatCurrency(counter)}
                </span>
              </div>
            ) : (
              <></>
            )}
            {props.totalPrice.props.children.split(":")[0] ? (
              <span>{props.totalPrice.props.children.split(":")[0]}: </span>
            ) : (
              <></>
            )}
            {props.totalPrice.props.children.split(":")[0]
              ? props.context.cultureFormatter.formatCurrency(price)
              : null}
          </div>
          {props.checkoutAsSignInUserButton}
          {props.goToCartButton}
        </Node>
      ) : (
        false
      )}
    </Node>
  );
};

export default CartIconView;
